import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { toLocalSeparator } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-progress-bar',
  styleUrl: 'ugc-review-progress-bar.scss',
  shadow: false,
})
export class UgcReviewProgressBar {
  render() {
    const {
      reviewStaticLanguage: { IDS_LBL_STARS_S = '', IDS_LBL_STARS = '' } = {},
      productInfo: { productId, urlName = '' },
      reviewSummary: { processItems },
      ids,
    } = state;

    if (!ids.length) return null;

    return (
      <div class="ugc-review-progress-wrap color-gray-500 mt-32">
        {processItems.map(item => (
          <div
            key={item.value}
            class="item flex-row-between-center pointer mb-8"
            onClick={() => (window.location.href = `/r/${urlName}/${productId}?ratings=${item.value}`)}
          >
            <span class="star-number-text fs-16 lh-24 mrl-8 shrink-0">
              {item.value} {item.value === 1 ? IDS_LBL_STARS : IDS_LBL_STARS_S}
            </span>
            <div class="percent-wrap w-full h-10 bg-gray-300 rounded-4">
              <span style={{ width: `${item.percentage || 0}%` }} class="block h-full bg-green-standard" />
            </div>
            <span class="fs-16 lh-24  shrink-0 each-count">{toLocalSeparator(item.count)}</span>
          </div>
        ))}
      </div>
    );
  }
}
